import React from "react";
type AnalyticsAttributeProps = {
  hidden: boolean;
};

export class AnalyticsAttribute extends React.Component<AnalyticsAttributeProps> {
  static displayName = "AnalyticsAttribute";

  trackClickByGame(id) {
    document.getElementById(id).click();
  }

  ClickAttr() {
    console.log("ClickAttr");
  }

  render() {
    (window as any).trackClickByGame = this.trackClickByGame;

    return (
      <div hidden={this.props.hidden}>
        {/* trivia  */}
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-JOIN-RATIGM-GAME_SELECTOR"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-JOIN-RATIGM-GAME_SELECTOR"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LOGIN-RATIGM-GAME_SELECTOR"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LOGIN-RATIGM-GAME_SELECTOR"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-JOIN-RATIGM-2X_POWER_UP"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-JOIN-RATIGM-2X_POWER_UP"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LOGIN-RATIGM-2X_POWER_UP"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LOGIN-RATIGM-2X_POWER_UP"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-JOIN-RATIGM-VIDEO_BONUS"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-JOIN-RATIGM-VIDEO_BONUS"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LOGIN-RATIGM-VIDEO_BONUS"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LOGIN-RATIGM-VIDEO_BONUS"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LOGIN-RATIGM-REWARDS"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LOGIN-RATIGM-REWARDS"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-ACTIVATE-RATIGM-REWARDS"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-ACTIVATE-RATIGM-REWARDS"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>

        {/* lets crossword  */}
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LCWD-FCBK"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LCWD-FCBK"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LCWD-TWIT"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LCWD-TWIT"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LCWD-EMAIL"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LCWD-EMAIL"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LCWD-COPY_LINK"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LCWD-COPY_LINK"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
        <div
          id="GAMES-BTN-CLK-MEMBERSHIP-LCWD-SKIP"
          data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-LCWD-SKIP"
          data-categoryid="AARP Games"
          onClick={this.ClickAttr}
        >
          &nbsp;
        </div>
      </div>
    );
  }
}
